import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_13 = {
  key: 0,
  class: "pf-seg"
}
const _hoisted_14 = { class: "pf-search" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 2,
  class: "pf-spacer"
}
const _hoisted_19 = { class: "full-table" }
const _hoisted_20 = { class: "table-labels" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["title", "onClick"]
const _hoisted_32 = ["href"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = {
  key: 2,
  style: {"white-space":"nowrap"}
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = { key: 5 }
const _hoisted_40 = {
  key: 6,
  style: {"text-align":"center"}
}
const _hoisted_41 = { class: "row-menu" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "row-menu-dropdown"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 10,
  class: "row-menu-divider"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 7,
  style: {"padding":"0"}
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { colspan: "42" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_57 = { class: "error-msg" }
const _hoisted_58 = { style: {"margin-bottom":"10px"} }
const _hoisted_59 = { style: {"margin-bottom":"10px"} }
const _hoisted_60 = { style: {"margin-bottom":"10px"} }
const _hoisted_61 = {
  key: 1,
  class: "error-msg-wrap"
}
const _hoisted_62 = { class: "form-wrapper slide-up" }
const _hoisted_63 = { class: "form-close" }
const _hoisted_64 = { style: {"margin-bottom":"15px","text-decoration":"underline"} }
const _hoisted_65 = {
  key: 0,
  class: "checkbox-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_ai_forge_name = _resolveComponent("ai-forge-name")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_ai_create_node = _resolveComponent("ai-create-node")!
  const _component_add_edit_node = _resolveComponent("add-edit-node")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_process_suggestion_form = _resolveComponent("process-suggestion-form")!
  const _component_add_node_to_folder = _resolveComponent("add-node-to-folder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "page-bar-sub" }, "Foundations", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.selectedType == 'ALL')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Make sure to view and sign off on updated items"))
            : (_ctx.selectedType == 'NODE')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Folders"))
              : (_ctx.selectedType == 'LINK')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Links"))
                : (_ctx.selectedType == 'VIDEO')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Videos"))
                  : (_ctx.selectedType == 'PROCESS')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Processes"))
                    : (_ctx.selectedType == 'TIMELINE')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Value Engines"))
                      : (_ctx.selectedType == 'SHEET')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Role Sheets"))
                        : (_ctx.selectedType == 'CHECKLIST')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Powerlists"))
                          : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.selectedType != 'ALL')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.selectedType == 'PROCESS' || _ctx.selectedType == 'VIDEO' || _ctx.selectedType == 'LINK')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ on: _ctx.selectedType == 'PROCESS' }),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/nodes/PROCESS')))
                  }, "Processes", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ on: _ctx.selectedType == 'VIDEO' }),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/nodes/VIDEO')))
                  }, "Videos", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ on: _ctx.selectedType == 'LINK' }),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/nodes/LINK')))
                  }, "Links", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _cache[36] || (_cache[36] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "7"
                }),
                _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQ) = $event)),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search())),
                placeholder: "Search",
                "aria-label": "Search"
              }, null, 544), [
                [_vModelText, _ctx.searchQ]
              ])
            ]),
            (_ctx.$store.state.user.isAdmin)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLocation) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.search()))
                }, [
                  _cache[37] || (_cache[37] = _createElementVNode("option", { value: "ALL" }, "All Locations", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: loc
                    }, _toDisplayString(loc), 9, _hoisted_15))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.selectedLocation]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDepartment) = $event)),
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.search()))
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("option", { value: "ALL" }, "All Departments", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.departments, (dep, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: dep
                }, _toDisplayString(dep), 9, _hoisted_16))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedDepartment]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedNodeType) = $event)),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.search()))
            }, [
              _cache[39] || (_cache[39] = _createElementVNode("option", { value: "ALL" }, "All Types", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.nodeTypes, (type, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: type
                }, _toDisplayString(type), 9, _hoisted_17))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedNodeType]
            ]),
            (_ctx.selectedType == 'PROCESS' || _ctx.$store.state.adminRolesCanEdit.includes(_ctx.$store.state.user.role))
              ? (_openBlock(), _createElementBlock("span", _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.selectedType == 'PROCESS')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showSuggestion = true))
                }, "Make a Suggestion"))
              : _createCommentVNode("", true),
            (_ctx.$store.state.adminRolesCanEdit.includes(_ctx.$store.state.user.role))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("div", {
                    class: "ai-btn",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAICreate = true))
                  }, [...(_cache[40] || (_cache[40] = [
                    _createElementVNode("svg", {
                      "aria-hidden": "true",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "15",
                      height: "15",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                      "fill-rule": "evenodd"
                    }, [
                      _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                    ], -1),
                    _createTextVNode(" The Forge ", -1)
                  ]))]),
                  _createElementVNode("div", {
                    onClick: _cache[13] || (_cache[13] = () => { _ctx.showAddProcess = true }),
                    class: "add-btn",
                    title: "Add manually"
                  }, "Add")
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_19, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_20, [
              _createElementVNode("td", {
                class: "table-sort-label",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeSort('Name')))
              }, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "Name", -1)),
                (_ctx.sortBy == 'Name' && _ctx.sortDirection == 'ASC')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createVNode(_component_svg_icon, { icon: "smtriangleup" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.sortBy == 'Name' && _ctx.sortDirection == 'DESC')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createVNode(_component_svg_icon, { icon: "smtriangledown" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showSignOff)
                ? (_openBlock(), _createElementBlock("td", _hoisted_23, "Signed"))
                : _createCommentVNode("", true),
              (_ctx.selectedType == 'ALL' || _ctx.selectedType == 'PROCESS' || _ctx.selectedType == 'TIMELINE' || _ctx.selectedType == 'SHEET')
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    class: "table-sort-label",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changeSort('ProcessOwnerNames')))
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("span", null, "Process Owner", -1)),
                    (_ctx.sortBy == 'ProcessOwnerNames' && _ctx.sortDirection == 'ASC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                          _createVNode(_component_svg_icon, { icon: "smtriangleup" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sortBy == 'ProcessOwnerNames' && _ctx.sortDirection == 'DESC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createVNode(_component_svg_icon, { icon: "smtriangledown" })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.isAdmin || _ctx.showSignOff)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 2,
                    class: "table-sort-label",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeSort('LastModified')))
                  }, [
                    _cache[43] || (_cache[43] = _createElementVNode("span", null, "Last Modified", -1)),
                    (_ctx.sortBy == 'LastModified' && _ctx.sortDirection == 'ASC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                          _createVNode(_component_svg_icon, { icon: "smtriangleup" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sortBy == 'LastModified' && _ctx.sortDirection == 'DESC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                          _createVNode(_component_svg_icon, { icon: "smtriangledown" })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.isAdmin || _ctx.showSignOff)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 3,
                    class: "table-sort-label",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeSort('LastUpdatedBy')))
                  }, [
                    _cache[44] || (_cache[44] = _createElementVNode("span", null, "Last Modifed By", -1)),
                    (_ctx.sortBy == 'LastUpdatedBy' && _ctx.sortDirection == 'ASC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                          _createVNode(_component_svg_icon, { icon: "smtriangleup" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sortBy == 'LastUpdatedBy' && _ctx.sortDirection == 'DESC')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                          _createVNode(_component_svg_icon, { icon: "smtriangledown" })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[45] || (_cache[45] = _createElementVNode("td", { style: {"padding":"0"} }, null, -1))
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                _createElementVNode("tr", null, [
                  (process.Type == 'LINK')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(_ctx.isFavorite(process) ? 'fav-star on' : 'fav-star'),
                          title: _ctx.isFavorite(process) ? 'Remove from favorites' : 'Add to favorites',
                          onClick: ($event: any) => (_ctx.toggleFavorite(process))
                        }, [
                          _createVNode(_component_svg_icon, {
                            icon: _ctx.isFavorite(process) ? 'starfilled' : 'star'
                          }, null, 8, ["icon"])
                        ], 10, _hoisted_31),
                        _createElementVNode("a", {
                          href: process.Link,
                          target: "_blank"
                        }, _toDisplayString(process.Name), 9, _hoisted_32)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_33, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(_ctx.isFavorite(process) ? 'fav-star on' : 'fav-star'),
                          title: _ctx.isFavorite(process) ? 'Remove from favorites' : 'Add to favorites',
                          onClick: ($event: any) => (_ctx.toggleFavorite(process))
                        }, [
                          _createVNode(_component_svg_icon, {
                            icon: _ctx.isFavorite(process) ? 'starfilled' : 'star'
                          }, null, 8, ["icon"])
                        ], 10, _hoisted_34),
                        _createVNode(_component_router_link, {
                          to: '/playbook/' + process.Slug
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ai_forge_name, {
                              name: process.Name
                            }, null, 8, ["name"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])),
                  (_ctx.showSignOff)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                        (process.HasSignOff)
                          ? (_openBlock(), _createBlock(_component_svg_icon, {
                              key: 0,
                              icon: "check",
                              style: {"width":"22px","height":"22px","margin-bottom":"-5px"}
                            }))
                          : _createCommentVNode("", true),
                        (process.SignOffDate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, " " + _toDisplayString(process.SignOffDate), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedType == 'ALL' || _ctx.selectedType == 'PROCESS' || _ctx.selectedType == 'TIMELINE' || _ctx.selectedType == 'SHEET')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(process.ProcessOwnerNames), 1))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.user.isAdmin || _ctx.showSignOff)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(process.LastModifiedString), 1))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.user.isAdmin || _ctx.showSignOff)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(process.LastUpdatedBy), 1))
                    : _createCommentVNode("", true),
                  (_ctx.rowMenuAvailable(process))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "row-menu-btn",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(process)), ["stop"])
                          }, [
                            _createVNode(_component_svg_icon, { icon: "dots" })
                          ], 8, _hoisted_42),
                          (_ctx.openMenuSlug == process.Slug)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.getRoutes(process))), ["prevent"])
                                    }, "Routes", 8, _hoisted_44))
                                  : _createCommentVNode("", true),
                                (_ctx.showsShare(process))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.sharePDF(process))), ["prevent"])
                                    }, "Share", 8, _hoisted_45))
                                  : _createCommentVNode("", true),
                                (_ctx.showsPDF(process))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.getPDF(process))), ["prevent"])
                                    }, "PDF", 8, _hoisted_46))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 3,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.editProcess(process, false))), ["prevent"])
                                    }, "Edit Details", 8, _hoisted_47))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && process.Type == 'PROCESS')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 4,
                                      to: '/edit-process/' + process.Slug,
                                      onClick: _ctx.closeRowMenu
                                    }, {
                                      default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                        _createTextVNode("Edit Process", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && process.Type == 'TIMELINE')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 5,
                                      to: '/edit-timeline/' + process.Slug,
                                      onClick: _ctx.closeRowMenu
                                    }, {
                                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                        _createTextVNode("Edit Value Engine", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && process.Type == 'SHEET')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 6,
                                      to: '/edit-sheet/' + process.Slug,
                                      onClick: _ctx.closeRowMenu
                                    }, {
                                      default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                        _createTextVNode("Edit Sheet", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && process.Type == 'CHECKLIST')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 7,
                                      to: '/edit-checklist/' + process.Slug,
                                      onClick: _ctx.closeRowMenu
                                    }, {
                                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                        _createTextVNode("Edit Checklist", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 8,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.editProcess(process, true))), ["prevent"])
                                    }, "Duplicate", 8, _hoisted_48))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 9,
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.addToFolder(process))), ["prevent"])
                                    }, "Add to Folder", 8, _hoisted_49))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 11,
                                      class: "row-menu-delete",
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.deleteProcess(process))), ["prevent"])
                                    }, "Remove", 8, _hoisted_51))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_52))
                ]),
                (process.showRoutes)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                      _createElementVNode("td", _hoisted_54, [
                        (!process.routes.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, "No Routes"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process.routes, (route, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'r'+j
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route, (r, k) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: 'rr'+k
                              }, [
                                _createVNode(_component_router_link, {
                                  to: '/playbook/'+r
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(r), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _cache[50] || (_cache[50] = _createTextVNode(" / ", -1))
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 2),
    (_ctx.showConfirmDeleteOrDraft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _cache[52] || (_cache[52] = _createElementVNode("div", null, "Would you like to remove this item?", -1)),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.unapproveItem('Draft'))),
                class: "btn"
              }, "Yes, Move to Draft")
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.unapproveItem('Needs Approval'))),
                class: "btn"
              }, "Yes, Move to Needs Approval")
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.unapproveItem('Inactive'))),
                class: "btn"
              }, "Yes, Move to Inactive")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                onClick: _cache[21] || (_cache[21] = () => { _ctx.showConfirmDeleteOrDraft = false; }),
                class: "btn-invert"
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSharePDF)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[22] || (_cache[22] = () => { _ctx.showSharePDF = false })
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("a", {
                onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.copyLink()), ["prevent"]))
              }, "Copy Link")
            ]),
            _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.shareData.email) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.shareData.email]
            ]),
            _cache[55] || (_cache[55] = _createElementVNode("h3", null, "Phone", -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.shareData.phone,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.shareData.phone) = $event)),
              placeholder: "Phone"
            }, null, 8, ["modelValue"]),
            (_ctx.shareProcess.Type == 'CHECKLIST')
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.shareData.wDescriptions) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.shareData.wDescriptions]
                  ]),
                  _cache[53] || (_cache[53] = _createElementVNode("h3", null, "w/ Lines", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.gettingPDF ? 'disable-button' : ''),
              type: "submit",
              value: "Send",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.getPDF(_ctx.shareProcess, true)))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPDF)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 2,
          url: _ctx.PDFUrl,
          onClose: _cache[28] || (_cache[28] = () => _ctx.showPDF = false)
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.showAICreate)
      ? (_openBlock(), _createBlock(_component_ai_create_node, {
          key: 3,
          "node-type": _ctx.aiCreateType,
          onClose: _cache[29] || (_cache[29] = ($event: any) => (_ctx.closeAICreate()))
        }, null, 8, ["node-type"]))
      : _createCommentVNode("", true),
    (_ctx.showAddProcess)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 4,
          type: _ctx.selectedType,
          onClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.closeAddProcess()))
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    (_ctx.showEditNode)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 5,
          node: _ctx.nodeToEdit,
          cloneNode: _ctx.cloneNode,
          onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.closeAddProcess()))
        }, null, 8, ["node", "cloneNode"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 6,
          onConfirm: _ctx.deleteProcessConfirm,
          onCancel: _cache[32] || (_cache[32] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to PERMANENTLY DELETE this item?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showSuggestion)
      ? (_openBlock(), _createBlock(_component_process_suggestion_form, {
          key: 7,
          onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showSuggestion = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showConfirmAddToFolder)
      ? (_openBlock(), _createBlock(_component_add_node_to_folder, {
          key: 8,
          toSlug: _ctx.slugToAddToFolder,
          onClose: _cache[34] || (_cache[34] = () => { _ctx.showConfirmAddToFolder = false; })
        }, null, 8, ["toSlug"]))
      : _createCommentVNode("", true)
  ]))
}